module.exports = __webpack_public_path__ + "static/media/img3.fc139e04.jpg";